import type { InsuranceRateStateType } from "../types/InsuranceTypes";
import type { AemFmComponent } from "../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import type { CommonSettingsType } from "../../../common-deprecated/settings/fetchCommonSettings";
import { getAemFlexibilityMatrixConfig } from "../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { formatPrice } from "../../../common-deprecated/Globalize";
import { getTagContent } from "../../../common-deprecated/utils";
import { replaceKeysInFormat } from "../../../common-deprecated/priceUtils";
import type { InsuranceSettingsType } from "../types/CommonSettingsType";

export const formatInsurancePrice = (
    insuranceReducer: InsuranceRateStateType,
    fmComponent: AemFmComponent,
    commonSettings: CommonSettingsType,
    showDisclaimerInline: boolean,
    carCode?: string,
): { labels: { key: string; value: string }[]; disclaimerParts: string[] } => {
    const { total, quoteInfo, info } = insuranceReducer;

    const priceFormat =
        getAemFlexibilityMatrixConfig(commonSettings, fmComponent, "new", carCode)?.config?.insurance?.format || "";

    // added a dynamic property here to support any returned key, currently used for makolab insurance in build
    const dynamicReplacements = Object.fromEntries(
        Object.entries(quoteInfo).map(([key, value]) => [key, value.formatted]),
    );
    const availableReplacements = {
        ...dynamicReplacements,
        price: total ? formatPrice(total, commonSettings.culture.name, true) : "",
    };

    const disclaimerTag = getTagContent("disclaimer", priceFormat!);
    const disclaimerContent = disclaimerTag && info.disclaimer ? disclaimerTag : null;
    const disclaimerParts = disclaimerContent && !showDisclaimerInline ? disclaimerContent.split("{icon}") : [];

    return {
        labels: replaceKeysInFormat(availableReplacements, priceFormat!),
        disclaimerParts,
    };
};

/**
 * Method which checks if the makolab insurance rate and calculator are used
 */
export const hasMakolabInsurance = (settings: InsuranceSettingsType): boolean => {
    return !!settings.insuranceAvailabilityService;
};
